module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture7-753441cb6e96e5a024f92cef5d08fd18.jpg";